"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGameSystemClass = void 0;
var base_1 = __importDefault(require("../base"));
var internal_1 = require("../internal");
var result_1 = require("../result");
var game_system_list_json_1 = __importDefault(require("../../lib/bcdice/game_system_list.json"));
function getGameSystemClass(gameSystemClass) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(command, internal) {
                return _super.call(this, command, internal !== null && internal !== void 0 ? internal : gameSystemClass.$new(command)) || this;
            }
            class_1.eval = function (command) {
                return result_1.parseResult(gameSystemClass.$eval(command));
            };
            return class_1;
        }(base_1.default)),
        _a.ID = gameSystemClass.$const_get('ID'),
        _a.NAME = gameSystemClass.$const_get('NAME'),
        _a.SORT_KEY = gameSystemClass.$const_get('SORT_KEY'),
        _a.HELP_MESSAGE = gameSystemClass.$const_get('HELP_MESSAGE'),
        _a.COMMAND_PATTERN = gameSystemClass.$command_pattern(),
        _a;
}
exports.getGameSystemClass = getGameSystemClass;
var Loader = /** @class */ (function () {
    function Loader() {
    }
    Loader.prototype.getGameSystemIdByName = function (name) {
        var _a;
        var id = (_a = this.listAvailableGameSystems().find(function (info) { return info.name === name; })) === null || _a === void 0 ? void 0 : _a.id;
        if (!id)
            throw new Error("GameSystem named " + name + " does not exists");
        return id;
    };
    Loader.prototype.getGameSystemInfo = function (id) {
        var info = this.listAvailableGameSystems().find(function (info) { return info.id === id; });
        if (!info)
            throw new Error('GameSystem is not found');
        return info;
    };
    Loader.prototype.getGameSystemClass = function (id) {
        var gameSystem = this.listLoadedGameSystems().find(function (a) { return a.ID === id; });
        if (!gameSystem)
            throw new Error("GameSystem " + id + " is not loaded");
        return gameSystem;
    };
    Loader.prototype.listLoadedGameSystems = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = internal_1.BCDice.GameSystem) === null || _a === void 0 ? void 0 : _a.$constants()) === null || _b === void 0 ? void 0 : _b.map(function (className) { return getGameSystemClass(internal_1.BCDice.GameSystem[className]); })) !== null && _c !== void 0 ? _c : [];
    };
    Loader.prototype.listAvailableGameSystems = function () {
        return game_system_list_json_1.default.gameSystems;
    };
    Loader.prototype.dynamicLoad = function (id) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var className, gameSystemClass;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        className = (_b = (_a = this.getGameSystemInfo(id)) === null || _a === void 0 ? void 0 : _a.className) !== null && _b !== void 0 ? _b : id;
                        if (!className.match(/^[A-Z]\w*$/))
                            throw new Error('Invalid id');
                        return [4 /*yield*/, this.dynamicImport(className)];
                    case 1:
                        _c.sent();
                        gameSystemClass = internal_1.BCDice.GameSystem.$const_get(className);
                        if (!gameSystemClass)
                            throw new Error('Failed to load game system');
                        return [2 /*return*/, getGameSystemClass(gameSystemClass)];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Loader.prototype.dynamicImport = function (className) {
        throw new Error('Not implemented');
    };
    return Loader;
}());
exports.default = Loader;
//# sourceMappingURL=loader.js.map